import { API_SUCCESS, API_FAIL } from '../actions'

export default (state = {}, action) => {
  switch (action.type) {
    case API_SUCCESS:
      return { ...state, ...action.data }
    case API_FAIL:
      return { ...state, ...action.data }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./services/app-state/search/reducer/index.js